import { render, staticRenderFns } from "./ReactionsBot.vue?vue&type=template&id=4c78b5a7&"
import script from "./ReactionsBot.vue?vue&type=script&lang=js&"
export * from "./ReactionsBot.vue?vue&type=script&lang=js&"
import style0 from "./ReactionsBot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports